import React from 'react';
import Conditional from '../../../common/conditional';
import classNames from './style.module.scss';

interface WarningNoticeProps {
	title: string;
	body: string;
	onAction?: () => void;
}

const WarningNotice: React.FC<WarningNoticeProps> = ({ title, body, onAction }) => {
    return ( 
		 <div className={classNames.warningNotice}>
			<div><i className="bi bi-exclamation-octagon-fill"></i></div>
			<div className="flex-fill ms-2">
				<h3>{title}</h3>
				<p>{body}</p>
			</div>
			<Conditional isVisible={onAction !== undefined}>
				<button onClick={onAction}>
					<i className="bi bi-arrow-clockwise"></i>
					<span>Tap to retry</span>
				</button>
			</Conditional>
	 </div>
     );
}
 
export default WarningNotice;